import React from "react";

import { Teaser, Row, Column } from "@ard-online/component-styleguide";

const team = [
  {
    type: "text",
    title: "Jenny Sommerfeld-Denkl",
    subline: "Leitung ARD Channels International",
    text: (
      <p className="mail">
        <a href="mailto:jenny.sommerfeld@wdr-mediagroup.com">
          jenny.sommerfeld@wdr-mediagroup.com
        </a>
      </p>
    ),
    image: {
      src: require("../images/jenny-sommerfeld.jpg"),
      alt: "Jenny Sommerfeld-Denkl",
    },
  },
  {
    type: "text",
    title: "Anke Burgmer",
    subline: "Distribution Manager",
    text: (
      <p className="mail">
        <a href="mailto:anke.burgmer@wdr-mediagroup.com">
          anke.burgmer@wdr-mediagroup.com
        </a>
      </p>
    ),
    image: {
      src: require("../images/anke-burgmer.jpg"),
      alt: "Anke Burgmer",
    },
  },
  {
    type: "text",
    title: "Meryl Marschall",
    subline: "Distribution Manager",
    text: (
      <p className="mail">
        <a href="mailto:meryl.marschall@wdr-mediagroup.com">
          meryl.marschall@wdr-mediagroup.com
        </a>
      </p>
    ),
    image: {
      src: require("../images/meryl-marschall.jpg"),
      alt: "Meryl Marschall",
    },
  },
  {
    type: "text",
    title: "Jennifer Hütt",
    subline: "Distribution Manager",
    text: (
      <p className="mail">
        <a href="mailto:jennifer.huett@wdr-mediagroup.com">
          jennifer.huett@wdr-mediagroup.com
        </a>
      </p>
    ),
    image: {
      src: require("../images/jennifer-huett.jpg"),
      alt: "Jennifer Hütt",
    },
  },
  {
    type: "text",
    title: "Cornelia Göppel",
    subline: "Account Manager kaufmännische Steuerung",
    text: (
      <p className="mail">
        <a href="mailto:cornelia.goeppel@wdr-mediagroup.com">
          cornelia.goeppel@wdr-mediagroup.com
        </a>
      </p>
    ),
    image: {
      src: require("../images/cornelia-goeppel.jpg"),
      alt: "Cornelia Göppel",
    },
  },
  {
    type: "text",
    title: "Claudia Lange",
    subline: "Referentin / Koordinatorin Marketing",
    text: (
      <p className="mail">
        <a href="mailto:claudia.lange@wdr-mediagroup.com">
          claudia.lange@wdr-mediagroup.com
        </a>
      </p>
    ),
    image: {
      src: require("../images/claudia-lange.jpg"),
      alt: "Claudia Lange",
    },
  },
];

export default function ContactSection() {
  return (
    <section id="contact">
      <Row>
        <Column>
          <h2>Ihr Kontakt zu ARD Channels International</h2>
          <h3>Unser Team</h3>
          {team.map((teamMember, index) => (
            <div className="teaserCont" key={index}>
              <Teaser {...teamMember} textPosition="besideImage" />
            </div>
          ))}
        </Column>
      </Row>
      <Row>
        <Column>
          <h3>Adresse</h3>
          <p>
            WDR mediagroup GmbH
            <br />
            ARD Channels International
            <br />
            Ludwigstrasse 11
            <br />
            50667 Köln
          </p>
          <p>Tel +49 221 2035-1951</p>
          <p className="mail">
            <a href="mailto:ard-channels-international@wdr-mediagroup.com">
              ard-channels-international@wdr-mediagroup.com
            </a>
          </p>
          <p className="website">
            <a href="https://ard-channels-international.com">
              www.ard-channels-international.com
            </a>
          </p>
        </Column>
      </Row>
    </section>
  );
}
